import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Loading from '../pages/LoadingPage';

const SuperProtectedRoute = ({ currentUser, element }) => {
    const {userId} = useParams();
  const [isAuth, setIsAuth] = useState(3); // 3 = Loading, 2 = Authenticated, 1 = Not authenticated

  useEffect(() => {
    const isAuthenticated = async () => {
      if(currentUser.id === Number(userId) && currentUser.status !== -1) {
          return 2;
      } else {
          return 1;
      }
    };

    const checkAuth = async () => {
      const authResult = await isAuthenticated();
      setIsAuth(authResult); // Correctly setting state based on the result of isAuthenticated
    };

    checkAuth();
  }, [currentUser, userId]); // Empty dependency array means this runs once on component mount


  if (isAuth === 3) {
    return <Loading />; // Show loading while authentication is being checked
  }

  return isAuth === 2 ? element : <Navigate to="/" />;
};

const RubyProtectedRoute = ({ currentUser, element }) => {
    const {userId} = useParams();
  const [isAuth, setIsAuth] = useState(3); // 3 = Loading, 2 = Authenticated, 1 = Not authenticated

  useEffect(() => {
    const isAuthenticated = async () => {
      if(currentUser.id === Number(userId) && currentUser.id === 1) {
          return 2;
      } else {
          return 1;
      }
    };

    const checkAuth = async () => {
      const authResult = await isAuthenticated();
      setIsAuth(authResult); // Correctly setting state based on the result of isAuthenticated
    };

    checkAuth();
  }, [currentUser, userId]); // Empty dependency array means this runs once on component mount


  if (isAuth === 3) {
    return <Loading />; // Show loading while authentication is being checked
  }

  return isAuth === 2 ? element : <Navigate to="/" />;
};

export default SuperProtectedRoute;
export {RubyProtectedRoute};